<template>
  <div class="connect-company">
    <section class="top-wrap">
      <tabs :tab-list="connectTab" default-active="me" @click="changeTab" class="tabs"></tabs>
      <el-tooltip class="tooltip-connect" effect="dark" placement="right">
        <div slot="content">
          对接我的企业：由我发起互联邀请，其他企业对接我的互联接口
          <br />
          我对接的企业：由其他企业发起互联邀请，我对接其互联接口
        </div>
        <i class="el-icon-question"></i>
      </el-tooltip>
    </section>
    <section class="main-wrap">
      <div class="row">
        <template v-if="!passive">
          <connect-search ref="connectSearch" @search="search" :types="types"></connect-search>
          <base-button type="primary" @click="$refs.saveConnectCompanyDialog.open()">
            新建
          </base-button>
        </template>
        <el-input
          v-else
          v-model="searchText"
          size="small"
          placeholder="企业名称"
          class="search-input"
          clearable
          @keyup.native.enter="search(searchText, ['targetName'])"
          @clear="search(searchText, ['targetName'])"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="search(searchText, ['targetName'])"
          ></el-button>
        </el-input>
      </div>
      <base-table ref="BaseTable" tableHeight="100%" :tableData="filterData" :pageInfo="pageInfo">
        <template v-slot:table-suffix>
          <el-table-column
            v-for="(item, index) in newCompanyTableColumns"
            :key="index"
            :prop="item.value"
            :label="item.label"
            :width="item.width"
            :min-width="item.minWidth"
            :align="item.align"
          >
            <template slot-scope="scope">
              <template v-if="item.value === 'operate'">
                <base-button
                  v-if="scope.row.status === '待互联'"
                  type="text"
                  @click="$refs.sendConnectRequestDialog.open(scope.row)"
                >
                  填写邀请码
                </base-button>
                <base-button
                  v-if="scope.row.status !== '待互联' && !passive"
                  @click="switchConnectState(scope.row)"
                  type="text"
                >
                  {{ scope.row.status === "互联中" ? "解除互联" : "恢复互联" }}
                </base-button>
                <base-button
                  v-if="scope.row.status === '互联中' && !passive"
                  @click="$refs.saveConnectCompanyDialog.open(scope.row)"
                  type="text"
                >
                  编辑
                </base-button>
                <base-button
                  v-if="scope.row.status !== '互联中' && !passive"
                  @click="deleteConnect(scope.row)"
                  type="text"
                >
                  删除
                </base-button>
              </template>
              <template v-else-if="item.value === 'status'">
                <el-tag
                  v-if="scope.row.status === '待互联'"
                  type="warning"
                  effect="dark"
                  size="mini"
                >
                  待互联
                </el-tag>
                <el-tag
                  v-else-if="scope.row.status === '互联中'"
                  type="success"
                  effect="dark"
                  size="mini"
                >
                  互联中
                </el-tag>
                <el-tag v-else type="info" effect="dark" size="mini">
                  已解除
                </el-tag>
              </template>
              <template v-else>
                {{ _.get(scope.row, item.value) }}
              </template>
            </template>
          </el-table-column>
        </template>
      </base-table>
    </section>
    <save-connect-company-dialog
      ref="saveConnectCompanyDialog"
      :passive="passive"
      @change="companyChanged"
    ></save-connect-company-dialog>
    <send-connect-request-dialog
      ref="sendConnectRequestDialog"
      @change="refresh"
    ></send-connect-request-dialog>
  </div>
</template>

<script>
import BaseTable from "@/components/BaseComponents/Table"
import BaseButton from "@/components/UIComponents/Button"
import SaveConnectCompanyDialog from "./SaveConnectCompanyDialog"
import SendConnectRequestDialog from "./SendConnectRequestDialog"
import TableController from "@/views/Backend/Admin/Layout/mixin/TableController"
import Tabs from "@/components/UIComponents/Tab"
import { companyTableColumns, connectTab } from "./static"
import {
  deleteCompanyConnect,
  getCompanyConnectList,
  getCompanyConnectType,
  lockCompanyConnect
} from "@/api/connect"
import ConnectSearch from "@/views/Company/Manage/Connect/ConnectSearch"

export default {
  name: "CompanyConnectType",
  components: {
    ConnectSearch,
    Tabs,
    BaseTable,
    BaseButton,
    SaveConnectCompanyDialog,
    SendConnectRequestDialog
  },
  data() {
    return {
      companyTableColumns,
      connectTab,
      list: [],
      filterData: [],
      pageInfo: {
        total: 1000,
        currentPage: 1,
        pageSize: 20
      },
      loadingItems: {
        data: true
      },
      types: [],
      passive: false,
      searchText: ""
    }
  },
  mixins: [TableController],
  created() {
    getCompanyConnectType().then(data => {
      this.types = data
    })
    this.refresh()
  },
  computed: {
    newCompanyTableColumns() {
      let companyTableColumns = []
      if (this.passive) {
        this.companyTableColumns.forEach(item => {
          if (item.value != "typeListStr" && item.value != "description") {
            companyTableColumns.push(item)
          }
        })
      } else companyTableColumns = this.companyTableColumns
      return companyTableColumns
    }
  },
  methods: {
    refresh() {
      this.loadingItems.data = true
      this.list = []
      this.getCompanyConnectList()
    },
    getCompanyConnectList() {
      let passive = this.passive
      getCompanyConnectList({ passive: passive }).then(data => {
        this.list = data.map(company => {
          company.typeListStr = company.typeList
            ?.map(type => type?.name)
            .filter(t => t)
            .join(",")
          return company
        })
        this.filterData = this.list
        this.passive = passive
        this.loadingItems.data = false
        this.resetPageInfo(this.filterData)
      })
    },
    deleteConnect(company) {
      this.$confirm("删除互联企业后，原互联设置将无法恢复。是否继续？", "删除企业", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteCompanyConnect(company.id).then(() => {
          this.$message.success("删除成功!")
          this.refresh()
        })
      })
    },
    switchConnectState(company) {
      if (company.status === "互联中") {
        this.$confirm("解除互联后，两企业将无法同步数据。是否解除？", "解除互联", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          lockCompanyConnect(company.id, true).then(() => {
            this.$message.success("删除成功!")
            this.refresh()
          })
        })
      } else {
        lockCompanyConnect(company.id, false).then(() => {
          this.$message.success("删除成功!")
          this.refresh()
        })
      }
    },
    companyChanged(company) {
      this.refresh()
      if (company.status === "待互联") {
        this.$refs.sendConnectRequestDialog.open(company)
      }
    },
    changeTab(key) {
      this.passive = key === "you"
      this.getCompanyConnectList()
    },
    search(searchInfo, filterKeys) {
      this.handleSearch({
        tableData: this.list,
        filterKeys: filterKeys,
        searchText: searchInfo
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.connect-company {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .top-wrap {
    display: flex;
    align-items: center;
    ::v-deep {
      .right {
        height: 100%;
        margin-left: auto;
        margin-right: 10px;
      }
    }
    .tabs {
      margin-top: 5px;
      ::v-deep .tab-title {
        font-size: 16px;
      }
    }
    .tooltip-connect {
      margin-top: -8px;
    }
  }
  .main-wrap {
    flex: 1 1;
    overflow: hidden;
    display: flex;
    flex-flow: column;
    .row {
      display: flex;
      align-items: center;
      justify-content: right;
      margin: 5px;
      .base-button {
        margin-left: 5px;
      }
      .search-input {
        width: 240px;
      }
    }
    .base-table {
      flex: 1;
      overflow: hidden;
      height: 0;
    }
  }
}
</style>
